module.exports = __webpack_public_path__ + "img/modifier-addresse-arrow.099e5610.svg";